import styled from "styled-components";


export const DashboardContainer = styled.div`
  display: flex;
  flex-direction: row;
  background-color: ${props => props.theme.white1};
  min-height: 900px;
  height: 100vh;
  overflow: auto;
`;

export const ContentContainer = styled.div`
  min-width: max-content;
  min-height: 800px;
  background-color: ${props => props.theme.white1};
  position: relative;
  border: 1px solid ${props => props.theme.white4};
  margin: 20px;
  padding: 20px;
  margin-right: 0;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
`;

export const FlexContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  flex-wrap: wrap;
`;

export const EditContainer = styled.div`
  min-width: 0;
  padding: 5px 10px;
  margin: 10px 0;
  border-radius: 10px;
  background-color: ${props => props.theme.white3};
  width: fit-content;
`;

export const Line = styled.div`
  align-self: stretch;
  width: 1px;
  background-color: ${props => props.theme.black2};
  margin: 10px 0;
`;

export const EditSpan = styled.div`
  display: flex;
  align-items: center;

  h3,h4,h5,h6{
    min-width: 120px;
    margin: 0;
  }
  .MuiAutocomplete-root {
    width: 220px;
    height: 28px;
    margin: 5px;
    background-color: ${props => props.theme.white1};
    border-radius: 5px;
    color: unset;
    
    &:focus {
      outline: none;
    }
  }
  .MuiInputLabel-outlined:not(.MuiInputLabel-shrink) {
    font-weight: 500;
    font-family: unset;
    transform: unset;
    top: 5px;
    left: 15px;
    font-size: 13px;
    color: unset;
  }

  .MuiFormLabel-root{
    color: unset;
  }
  .MuiFormLabel-root.Mui-focused{
    color: unset;

  }
  .MuiAutocomplete-root .MuiOutlinedInput-root {
    height: 28px;
    color: unset;
    background-color: ${props => props.theme.white1};
  }
  .MuiOutlinedInput-notchedOutline{
    border: 0;
  }
  .MuiSvgIcon-root{
    color: ${props => props.theme.black1};
  }
  .MuiAutocomplete-paper{
    background-color: ${props => props.theme.white1};
    color: unset;
  }
`;

export const SelectContainer = styled.select`
  width: 220px;
  height: 28px;
  margin: 5px;
  margin-right: 20px;
  padding: 0 10px;
  border-radius: 5px;
  border: 0;
  background-color: ${props => props.theme.white1};
  color: unset;

  &:focus {
    outline: none;
  }
`;

export const Input = styled.input`
  background-color: ${props => props.theme.white1};
  color: unset;
  margin: 5px;
  padding-left: 15px;
  width: 220px;
  height: 28px;
  border-radius: 5px;
  border: 0;
  &:focus {
    outline: none;
  }
`;

export const TextArea = styled.textarea`
  background-color: ${props => props.theme.white1};
  min-width: 400px;
  width: 100%;
  height: clamp(300px, 34vh, 380px);
  resize: none;
  outline: none;
  padding: 10px;
  border: 0;
  font-size: 14px;
  color: unset;
  box-sizing: border-box;
  
  &:focus {
    outline: none;
  }
`;

export const ButtonSpan = styled.span`
  height: 40px;
  width: 100%;
  display: flex;
  flex-direction: row-reverse;
  align-items: flex-end;
`;

export const Button = styled.button`
  background-color: ${props => props.theme.white3};
  color: unset;
  font-weight: 500;
  font-size: 18px;
  width: 100px;
  height: 32px;
  border-radius: 5px;
  border: 0;
  &:focus {
    outline: none;
  }
  &:hover {
    background-color: ${props => props.theme.white5};
  }
`;

export const ResultContainer = styled.div`
  background-color: ${props => props.theme.white1};
  height: 600px;
  min-width: 200px;
  overflow-y: scroll;
  padding: 5px;
`;

export const TabBar = styled.div`
  display: flex;
  gap: 8px;
  width: fit-content;
  margin: 12px 0 16px;
  padding: 4px;
  border-radius: 10px;
  background-color: ${props => props.theme.white3};
`;

export const TabButton = styled.button`
  min-width: 88px;
  height: 36px;
  padding: 0 14px;
  border: 0;
  border-radius: 8px;
  background-color: ${props => (props.$active ? props.theme.white1 : "transparent")};
  color: ${props => props.theme.black1};
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: ${props => (props.$active ? "0 1px 3px rgba(0, 0, 0, 0.12)" : "none")};
  transition: background-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;

  &:hover {
    background-color: ${props => (props.$active ? props.theme.white1 : props.theme.white4)};
  }

  &:active {
    transform: translateY(1px);
  }

  &:focus {
    outline: none;
  }
`;

export const ActionBar = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 12px;
`;

export const ActionButton = styled.button`
  min-width: 110px;
  height: 40px;
  padding: 0 14px;
  border-radius: 8px;
  border: 1px solid ${props => props.theme.white4};
  background-color: ${props => (props.$variant === "primary" ? props.theme.black1 : props.theme.white1)};
  color: ${props => (props.$variant === "primary" ? props.theme.white1 : props.theme.black1)};
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.15s ease, opacity 0.15s ease, background-color 0.15s ease;

  &:hover {
    opacity: 0.92;
  }

  &:active {
    transform: translateY(1px);
  }
`;

export const FileMeta = styled.div`
  margin-top: 10px;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid ${props => props.theme.white4};
  background-color: ${props => props.theme.white1};
  font-size: 13px;
  line-height: 1.5;
`;

export const HistoryPanel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const HistoryTop = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
`;

export const HistoryHint = styled.p`
  margin: 4px 0 0;
  color: ${props => props.theme.black2};
  font-size: 13px;
`;

export const HistoryTableWrap = styled.div`
  overflow-x: auto;
  border: 1px solid ${props => props.theme.white4};
  border-radius: 10px;
  background-color: ${props => props.theme.white1};
`;

export const HistoryTable = styled.table`
  width: 100%;
  min-width: 760px;
  border-collapse: collapse;
`;

export const HistoryTh = styled.th`
  padding: 12px 10px;
  text-align: left;
  font-size: 13px;
  background-color: ${props => props.theme.white3};
  border-bottom: 1px solid ${props => props.theme.white4};
`;

export const HistoryTd = styled.td`
  padding: 12px 10px;
  border-top: 1px solid ${props => props.theme.white4};
  font-size: 13px;
  vertical-align: top;
`;

export const EmptyState = styled.div`
  padding: 24px 16px;
  text-align: center;
  color: ${props => props.theme.black2};
  background-color: ${props => props.theme.white1};
  border: 1px dashed ${props => props.theme.white4};
  border-radius: 10px;
`;
